var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _g, _path1, _path10, _path11, _ellipse, _path12, _path13, _ellipse2, _path14, _path15, _ellipse3, _path16, _path17, _ellipse4, _path18, _path19, _ellipse5, _path20, _path21, _ellipse6, _path22, _path23, _ellipse7, _path24, _path25, _ellipse8, _path26, _path27, _ellipse9, _g2, _rect, _rect2, _path28, _path29, _path30, _path31, _g3, _g4, _g5, _rect3, _rect4, _path32, _path33, _path34, _path35, _g6, _g7, _path36, _path37, _g8, _rect5, _rect6, _path38, _path39, _path40, _path41, _g9, _rect7, _rect8, _path42, _path43, _path44, _path45, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFalltree(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 318,
    height: 1545,
    viewBox: "0 0 318 1545",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-11.8154 78L137.141 372.75H-160.772L-11.8154 78Z",
    fill: "#307357"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-47.0221 297.528L25.1846 272.5L51.0042 289.121L49.5084 242.78L65.5616 256.546L46.2952 194.986L70.1166 241.15L112.593 329.404L-4.54585 385.782L-47.0221 297.528Z",
    fill: "#245742",
    fillOpacity: 0.71
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-8.31543 229L194.768 621.25H-211.398L-8.31543 229Z",
    fill: "#307357"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-16.2956 504.168L28.7696 432.68L81.7307 495.76L80.235 449.419L96.2881 463.185L77.0218 401.626L100.843 447.79L143.319 536.044L26.1807 592.422L-16.2956 504.168Z",
    fill: "#245742",
    fillOpacity: 0.71
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-97.2308 110.326L187.344 477.865L-309.355 523.934L-97.2308 110.326Z",
    fill: "#307357"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M-32.3412 450.085L39.6846 435L62.143 450.696L74.5707 420.912L85.5242 430.715L131.685 450.084L115.185 389.001L181.184 475.501L-18.8279 509.231L-32.3412 450.085Z",
    fill: "#245742",
    fillOpacity: 0.71
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6846 596L263.098 988.25H-151.729L55.6846 596Z",
    fill: "#307357"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6846 374L230.624 766.25H-203.255L13.6846 374Z",
    fill: "#307357"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M-18.4036 721.106L66.1322 685.843L95.1489 732.938L115.635 704.787L126.99 715.84L178.923 740.59L170.425 677.867L233.748 771.754L-13.139 781.548L-18.4036 721.106Z",
    fill: "#245742",
    fillOpacity: 0.71
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M-33.4036 916.106L19.6846 916.106L43.185 853L122.684 937.5L122.684 875.5L158.685 916.106L184.803 933.771L175.981 871.076L209.185 888L245.19 964.451L-28.1391 976.547L-33.4036 916.106Z",
    fill: "#245742",
    fillOpacity: 0.71
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dn_30453_30598)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.571 750.156C251.171 775.631 230.26 803.934 202.501 800.329L147.596 793.197C136.792 791.794 125.883 794.858 117.391 801.681L89.3871 824.18C78.6795 832.783 64.3067 835.29 51.3188 830.821L3.54248 814.38C-6.57442 810.899 -13.4978 801.541 -13.8672 790.848C-14.2531 779.679 -7.41195 769.528 3.08571 765.694L32.8204 754.834C39.9369 752.234 47.9192 754.385 52.7666 760.208C58.4632 767.051 68.3158 768.681 75.9132 764.039L116.448 739.269C128.232 732.069 143.452 734.139 152.885 744.224L163.509 755.583C174.481 767.313 194.071 762.415 198.231 746.902C201.183 735.894 212.56 729.418 223.534 732.495C229.344 734.124 234.142 738.233 236.642 743.725L239.571 750.156Z",
    fill: "url(#paint0_linear_30453_30598)"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M-57.8154 9C27.1983 76.7751 -93.7916 250.364 64.6846 331C234.685 417.5 -68.8154 504.5 -24.7432 646.799C80.05 642.213 371.612 717.742 270.685 860C148.302 1032.5 344.192 1171.28 308.83 1292.47C273.883 1412.24 -42.3239 1395.19 140.712 1544.09",
    stroke: "#333333",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8373 697.98C70.5607 697.43 66.8839 691.225 67.6249 684.121C72.3606 674.852 74.0069 666.604 79.2835 667.154C84.5601 667.705 84.6036 675.287 86.7331 686.114C85.9921 693.218 81.1139 698.531 75.8373 697.98Z",
    fill: "#1481FE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M86.679 671.838C86.5165 672.93 85.4991 673.684 84.4065 673.522L74.0506 671.981C72.958 671.819 72.2041 670.801 72.3666 669.709L74.258 656.993L88.5704 659.122L86.679 671.838Z",
    fill: "#333333"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.5497,
    cy: 690.843,
    rx: 5.75972,
    ry: 3.7917,
    transform: "rotate(138.735 78.5497 690.843)",
    fill: "#67CCFF",
    fillOpacity: 0.7
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5824 398.917C71.6614 403.862 75.5014 409.968 82.1592 412.554C92.5676 412.575 100.657 414.879 102.578 409.934C104.499 404.988 97.774 401.486 89.1158 394.645C82.458 392.059 75.5034 393.972 73.5824 398.917Z",
    fill: "#E64338"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M101.79 401.217C100.744 400.862 99.6081 401.423 99.2535 402.469L95.8926 412.385C95.538 413.431 96.0986 414.566 97.1448 414.921L109.32 419.047L113.965 405.343L101.79 401.217Z",
    fill: "#333333"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.75983,
    cy: 3.79164,
    rx: 5.75983,
    ry: 3.79164,
    transform: "matrix(-0.930083 0.36735 0.367342 0.930086 85.1338 394.123)",
    fill: "#FFE38E",
    fillOpacity: 0.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M292.448 1075.8C295.095 1080.4 292.224 1087.01 286.034 1090.58C275.749 1092.18 268.101 1095.68 265.454 1091.08C262.807 1086.48 268.925 1082 276.448 1073.93C282.637 1070.37 289.801 1071.2 292.448 1075.8Z",
    fill: "#1481FE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M264.914 1082.34C265.895 1081.83 267.102 1082.22 267.611 1083.2L272.433 1092.49C272.942 1093.47 272.56 1094.68 271.579 1095.19L260.169 1101.11L253.504 1088.26L264.914 1082.34Z",
    fill: "#333333"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.75964,
    cy: 3.79176,
    rx: 5.75964,
    ry: 3.79176,
    transform: "matrix(0.974969 0.222343 -0.222349 0.974967 280.305 1072.81)",
    fill: "#4EB6FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0537 269.813C51.3696 272.898 51.5011 280.109 47.3474 285.92C38.6512 291.639 33.1449 297.997 28.8291 294.912C24.5132 291.827 28.2213 285.213 31.7183 274.747C35.8719 268.937 42.7378 266.727 47.0537 269.813Z",
    fill: "#FEC414"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7151 287.186C25.3962 286.316 26.6532 286.163 27.5229 286.844L35.766 293.3C36.6357 293.981 36.7886 295.238 36.1076 296.107L28.1813 306.229L16.7889 297.308L24.7151 287.186Z",
    fill: "#333333"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.1709,
    cy: 274.678,
    rx: 5.75972,
    ry: 3.7917,
    transform: "rotate(-11.6609 41.1709 274.678)",
    fill: "#FFE38E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M185.531 647.565C190.587 649.173 192.93 655.995 190.766 662.801C184.251 670.918 180.968 678.663 175.912 677.055C170.856 675.447 172.35 668.012 172.457 656.979C174.622 650.172 180.475 645.958 185.531 647.565Z",
    fill: "#FEC414"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M169.62 670.971C170 669.934 171.149 669.402 172.186 669.783L182.015 673.389C183.052 673.769 183.585 674.919 183.204 675.956L178.776 688.025L165.192 683.041L169.62 670.971Z",
    fill: "#333333"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.75966,
    cy: 3.79174,
    rx: 5.75966,
    ry: 3.79174,
    transform: "matrix(0.869686 -0.493606 0.493601 0.869689 174.55 653.55)",
    fill: "#FFE38E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M308.896 873.983C312.244 869.868 310.467 862.877 304.926 858.37C295.029 855.149 288.039 850.47 284.691 854.585C281.343 858.7 286.666 864.101 292.802 873.272C298.342 877.78 305.547 878.098 308.896 873.983Z",
    fill: "#FEC414"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M282.762 863.124C283.649 863.783 284.901 863.599 285.56 862.712L291.807 854.31C292.466 853.423 292.281 852.17 291.395 851.511L281.078 843.841L272.445 855.454L282.762 863.124Z",
    fill: "#333333"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.75967,
    cy: 3.79174,
    rx: 5.75967,
    ry: 3.79174,
    transform: "matrix(0.997974 -0.0636174 -0.0636221 -0.997974 296.431 874.995)",
    fill: "#FFE38E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8507 517.944C78.7692 514.368 78.0427 507.192 73.228 501.916C63.9138 497.271 57.6908 491.612 53.7723 495.188C49.8538 498.764 54.3217 504.891 59.0377 514.867C63.8524 520.143 70.9321 521.52 74.8507 517.944Z",
    fill: "#5FDB12"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6041 503.35C51.3837 504.132 52.65 504.135 53.4325 503.355L60.8499 495.966C61.6324 495.186 61.6348 493.92 60.8553 493.137L51.7824 484.029L41.5312 494.242L50.6041 503.35Z",
    fill: "#333333"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.75964,
    cy: 3.79176,
    rx: 5.75964,
    ry: 3.79176,
    transform: "matrix(0.996441 0.084288 0.0842806 -0.996442 62.374 517.105)",
    fill: "#9CFF5F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M234.682 769.832C238.394 773.621 245.54 772.641 250.642 767.643C254.955 758.17 260.391 751.751 256.678 747.961C252.965 744.172 247 748.854 237.198 753.92C232.095 758.918 230.969 766.042 234.682 769.832Z",
    fill: "#E64338"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M248.411 745.084C247.657 745.891 247.699 747.157 248.506 747.911L256.153 755.062C256.959 755.817 258.225 755.775 258.979 754.968L267.761 745.578L257.192 735.695L248.411 745.084Z",
    fill: "#333333"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.75968,
    cy: 3.79173,
    rx: 5.75968,
    ry: 3.79173,
    transform: "matrix(-0.0489903 0.998799 0.998799 0.0489865 235.078 757.33)",
    fill: "#F29363"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M118.205 615.585C122.811 612.952 123.671 605.791 120.126 599.59C112.052 593.022 107.216 586.139 102.611 588.772C98.0051 591.405 101.026 598.36 103.447 609.126C106.992 615.326 113.6 618.218 118.205 615.585Z",
    fill: "#FEC414"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7361 596.04C98.3257 596.974 99.5609 597.253 100.495 596.664L109.348 591.075C110.282 590.485 110.562 589.25 109.972 588.316L103.109 577.445L90.8734 585.169L97.7361 596.04Z",
    fill: "#333333"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.75979,
    cy: 3.79166,
    rx: 5.75979,
    ry: 3.79166,
    transform: "matrix(0.953915 0.300076 0.300082 -0.953913 106.212 612.038)",
    fill: "#FFE38E"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30453_30598)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 67.4365,
    y: 518.171,
    width: 89,
    height: 61,
    rx: 20,
    transform: "rotate(-5.04778 67.4365 518.171)",
    fill: "#9AD7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1472 525.289L89.6751 531.265M89.1472 525.289L85.2943 529.888M89.1472 525.289L83.1705 525.817M89.1472 525.289L84.5477 521.436M89.1472 525.289L88.6193 519.312M89.1472 525.289L93.0001 520.689M89.1472 525.289L95.124 524.761M89.1472 525.289L93.7467 529.142M89.2792 526.783L89.3169 527.21M89.4112 528.277L89.5432 529.771L89.5872 530.269M88.184 526.439L87.9088 526.767M87.2208 527.588L86.2576 528.738L85.9365 529.122M87.653 525.421L87.2261 525.458M86.1589 525.553L84.6647 525.685L84.1666 525.729M87.9974 524.325L87.6688 524.05M86.8475 523.362L85.6976 522.399L85.3143 522.078M89.0152 523.794L88.9775 523.368M88.8833 522.3L88.7513 520.806L88.7073 520.308M90.1105 524.139L90.3857 523.81M91.0737 522.989L92.0369 521.839L92.358 521.456M90.6414 525.157L91.0683 525.119M92.1356 525.025L93.6298 524.893L94.1278 524.849M90.2971 526.252L90.6256 526.527M91.447 527.215L92.5968 528.178L92.9801 528.499",
    stroke: "#9670DD",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8367 533.933L71.3646 539.91M70.8367 533.933L66.9838 538.533M70.8367 533.933L64.8599 534.461M70.8367 533.933L66.2372 530.08M70.8367 533.933L70.3088 527.956M70.8367 533.933L74.6896 529.334M70.8367 533.933L76.8134 533.405M70.8367 533.933L75.4362 537.786M70.9687 535.427L71.0064 535.854M71.1006 536.922L71.2326 538.416L71.2766 538.914M69.8735 535.083L69.5983 535.412M68.9102 536.233L67.947 537.383L67.6259 537.766M69.3425 534.065L68.9156 534.103M67.8483 534.197L66.3541 534.329L65.8561 534.373M69.6868 532.97L69.3583 532.695M68.5369 532.007L67.3871 531.044L67.0038 530.722M70.7047 532.439L70.667 532.012M70.5727 530.945L70.4407 529.451L70.3967 528.953M71.7999 532.783L72.0751 532.455M72.7631 531.633L73.7263 530.484L74.0474 530.1M72.3309 533.801L72.7578 533.763M73.825 533.669L75.3192 533.537L75.8173 533.493M71.9866 534.896L72.3151 535.172M73.1364 535.86L74.2863 536.823L74.6696 537.144",
    stroke: "#9670DD",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8113 544.039L93.3392 550.015M92.8113 544.039L88.9584 548.638M92.8113 544.039L86.8346 544.567M92.8113 544.039L88.2118 540.186M92.8113 544.039L92.2834 538.062M92.8113 544.039L96.6642 539.439M92.8113 544.039L98.788 543.511M92.8113 544.039L97.4108 547.892M92.9433 545.533L92.981 545.96M93.0752 547.027L93.2072 548.521L93.2512 549.019M91.8481 545.189L91.5729 545.517M90.8848 546.338L89.9216 547.488L89.6005 547.872M91.3171 544.171L90.8902 544.208M89.8229 544.303L88.3287 544.435L87.8307 544.479M91.6614 543.075L91.3329 542.8M90.5116 542.112L89.3617 541.149L88.9784 540.828M92.6793 542.544L92.6416 542.118M92.5473 541.05L92.4154 539.556L92.3714 539.058M93.7745 542.889L94.0497 542.56M94.7377 541.739L95.701 540.589L96.022 540.206M94.3055 543.907L94.7324 543.869M95.7997 543.775L97.2938 543.643L97.7919 543.599M93.9612 545.002L94.2897 545.277M95.111 545.965L96.2609 546.928L96.6442 547.249",
    stroke: "#9670DD",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8406 556.404L78.3685 562.381M77.8406 556.404L73.9877 561.003M77.8406 556.404L71.8639 556.932M77.8406 556.404L73.2411 552.551M77.8406 556.404L77.3127 550.427M77.8406 556.404L81.6935 551.804M77.8406 556.404L83.8173 555.876M77.8406 556.404L82.4401 560.257M77.9726 557.898L78.0103 558.325M78.1045 559.392L78.2365 560.886L78.2805 561.384M76.8774 557.554L76.6022 557.882M75.9141 558.704L74.9509 559.854L74.6298 560.237M76.3464 556.536L75.9195 556.574M74.8522 556.668L73.358 556.8L72.86 556.844M76.6907 555.441L76.3622 555.165M75.5408 554.477L74.391 553.514L74.0077 553.193M77.7086 554.91L77.6709 554.483M77.5766 553.416L77.4446 551.921L77.4007 551.423M78.8038 555.254L79.079 554.925M79.767 554.104L80.7303 552.954L81.0513 552.571M79.3348 556.272L79.7617 556.234M80.829 556.14L82.3231 556.008L82.8212 555.964M78.9905 557.367L79.319 557.642M80.1403 558.33L81.2902 559.294L81.6735 559.615",
    stroke: "#9670DD",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9187 567.858L96.4466 573.835M95.9187 567.858L92.0658 572.457M95.9187 567.858L89.942 568.386M95.9187 567.858L91.3192 564.005M95.9187 567.858L95.3908 561.881M95.9187 567.858L99.7716 563.259M95.9187 567.858L101.895 567.33M95.9187 567.858L100.518 571.711M96.0507 569.352L96.0884 569.779M96.1827 570.846L96.3146 572.341L96.3586 572.839M94.9555 569.008L94.6803 569.336M93.9923 570.158L93.029 571.308L92.708 571.691M94.4245 567.99L93.9976 568.028M92.9303 568.122L91.4362 568.254L90.9381 568.298M94.7688 566.895L94.4403 566.62M93.619 565.932L92.4691 564.968L92.0858 564.647M95.7867 566.364L95.749 565.937M95.6548 564.87L95.5228 563.375L95.4788 562.877M96.8819 566.708L97.1571 566.38M97.8452 565.558L98.8084 564.408L99.1295 564.025M97.4129 567.726L97.8398 567.688M98.9071 567.594L100.401 567.462L100.899 567.418M97.0686 568.821L97.3971 569.096M98.2184 569.784L99.3683 570.748L99.7516 571.069",
    stroke: "#9670DD",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5532 520.264C72.6173 517.566 75.1123 518.345 75.1123 518.345C75.1123 518.345 76.9876 516.261 81.2233 517.805C96.2921 523.296 86.2466 546.991 96.6196 556.752C112.294 571.504 151.538 538.349 162.235 557.25C165.254 562.585 167.103 564.088 161.735 568C148.461 577.674 98.4407 577.369 98.4407 577.369C98.4407 577.369 83.9003 580.429 73.1824 572.673C65.0005 566.752 65.7679 552.483 65.649 543.735C65.5241 534.539 59.1926 526.478 68.5532 520.264Z",
    fill: "#5D8799",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.452 515.528L131.98 521.505M131.452 515.528L127.599 520.127M131.452 515.528L125.475 516.056M131.452 515.528L126.852 511.675M131.452 515.528L130.924 509.551M131.452 515.528L135.305 510.928M131.452 515.528L137.429 515M131.452 515.528L136.051 519.381M131.584 517.022L131.622 517.449M131.716 518.516L131.848 520.01L131.892 520.509M130.489 516.678L130.213 517.006M129.525 517.828L128.562 518.978L128.241 519.361M129.958 515.66L129.531 515.698M128.464 515.792L126.969 515.924L126.471 515.968M130.302 514.565L129.974 514.289M129.152 513.601L128.002 512.638L127.619 512.317M131.32 514.034L131.282 513.607M131.188 512.54L131.056 511.045L131.012 510.547M132.415 514.378L132.69 514.05M133.378 513.228L134.342 512.078L134.663 511.695M132.946 515.396L133.373 515.358M134.44 515.264L135.934 515.132L136.433 515.088M132.602 516.491L132.93 516.766M133.752 517.454L134.902 518.418L135.285 518.739",
    stroke: "#9670DD",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.454 526.25L146.982 532.226M146.454 526.25L142.601 530.849M146.454 526.25L140.477 526.778M146.454 526.25L141.854 522.397M146.454 526.25L145.926 520.273M146.454 526.25L150.307 521.65M146.454 526.25L152.431 525.722M146.454 526.25L151.053 530.102M146.586 527.744L146.624 528.171M146.718 529.238L146.85 530.732L146.894 531.23M145.491 527.399L145.215 527.728M144.527 528.549L143.564 529.699L143.243 530.082M144.96 526.382L144.533 526.419M143.466 526.514L141.971 526.646L141.473 526.69M145.304 525.286L144.975 525.011M144.154 524.323L143.004 523.36L142.621 523.039M146.322 524.755L146.284 524.328M146.19 523.261L146.058 521.767L146.014 521.269M147.417 525.1L147.692 524.771M148.38 523.95L149.344 522.8L149.665 522.417M147.948 526.118L148.375 526.08M149.442 525.986L150.936 525.854L151.434 525.81M147.604 527.213L147.932 527.488M148.754 528.176L149.903 529.139L150.287 529.46",
    stroke: "#9670DD",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.223 535.714L130.751 541.691M130.223 535.714L126.371 540.314M130.223 535.714L124.247 536.242M130.223 535.714L125.624 531.862M130.223 535.714L129.695 529.738M130.223 535.714L134.076 531.115M130.223 535.714L136.2 535.187M130.223 535.714L134.823 539.567M130.355 537.209L130.393 537.636M130.487 538.703L130.619 540.197L130.663 540.695M129.26 536.864L128.985 537.193M128.297 538.014L127.334 539.164L127.013 539.547M128.729 535.846L128.302 535.884M127.235 535.978L125.741 536.11L125.243 536.154M129.074 534.751L128.745 534.476M127.924 533.788L126.774 532.825L126.39 532.504M130.091 534.22L130.054 533.793M129.959 532.726L129.827 531.232L129.783 530.734M131.187 534.565L131.462 534.236M132.15 533.415L133.113 532.265L133.434 531.882M131.718 535.582L132.144 535.545M133.212 535.45L134.706 535.318L135.204 535.275M131.373 536.678L131.702 536.953M132.523 537.641L133.673 538.604L134.056 538.925",
    stroke: "#9670DD",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.651 539.404L157.179 545.381M156.651 539.404L152.798 544.003M156.651 539.404L150.674 539.932M156.651 539.404L152.052 535.551M156.651 539.404L156.123 533.427M156.651 539.404L160.504 534.804M156.651 539.404L162.628 538.876M156.651 539.404L161.251 543.257M156.783 540.898L156.821 541.325M156.915 542.392L157.047 543.886L157.091 544.384M155.688 540.554L155.413 540.882M154.725 541.704L153.761 542.854L153.44 543.237M155.157 539.536L154.73 539.574M153.663 539.668L152.169 539.8L151.671 539.844M155.501 538.441L155.173 538.165M154.351 537.477L153.202 536.514L152.818 536.193M156.519 537.91L156.481 537.483M156.387 536.416L156.255 534.921L156.211 534.423M157.614 538.254L157.89 537.925M158.578 537.104L159.541 535.954L159.862 535.571M158.145 539.272L158.572 539.234M159.639 539.14L161.134 539.008L161.632 538.964M157.801 540.367L158.13 540.642M158.951 541.33L160.101 542.294L160.484 542.615",
    stroke: "#9670DD",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.669 551.504L145.197 557.481M144.669 551.504L140.816 556.104M144.669 551.504L138.692 552.032M144.669 551.504L140.069 547.652M144.669 551.504L144.141 545.528M144.669 551.504L148.522 546.905M144.669 551.504L150.645 550.977M144.669 551.504L149.268 555.357M144.801 552.999L144.838 553.426M144.933 554.493L145.065 555.987L145.109 556.485M143.705 552.654L143.43 552.983M142.742 553.804L141.779 554.954L141.458 555.337M143.175 551.636L142.748 551.674M141.68 551.768L140.186 551.9L139.688 551.944M143.519 550.541L143.19 550.266M142.369 549.578L141.219 548.615L140.836 548.294M144.537 550.01L144.499 549.583M144.405 548.516L144.273 547.022L144.229 546.524M145.632 550.355L145.907 550.026M146.595 549.205L147.558 548.055L147.879 547.672M146.163 551.372L146.59 551.335M147.657 551.241L149.151 551.109L149.649 551.065M145.819 552.468L146.147 552.743M146.968 553.431L148.118 554.394L148.502 554.715",
    stroke: "#9670DD",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.59 551.712L120.118 557.689M119.59 551.712L115.737 556.312M119.59 551.712L113.613 552.24M119.59 551.712L114.99 547.86M119.59 551.712L119.062 545.736M119.59 551.712L123.443 547.113M119.59 551.712L125.566 551.185M119.59 551.712L124.189 555.565M119.722 553.207L119.759 553.634M119.854 554.701L119.986 556.195L120.03 556.693M118.626 552.862L118.351 553.191M117.663 554.012L116.7 555.162L116.379 555.545M118.095 551.844L117.669 551.882M116.601 551.976L115.107 552.108L114.609 552.152M118.44 550.749L118.111 550.474M117.29 549.786L116.14 548.823L115.757 548.502M119.458 550.218L119.42 549.791M119.326 548.724L119.194 547.23L119.15 546.732M120.553 550.563L120.828 550.234M121.516 549.413L122.479 548.263L122.8 547.88M121.084 551.581L121.511 551.543M122.578 551.449L124.072 551.317L124.57 551.273M120.739 552.676L121.068 552.951M121.889 553.639L123.039 554.602L123.423 554.923",
    stroke: "#9670DD",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.867 565.686L132.395 571.663M131.867 565.686L128.014 570.286M131.867 565.686L125.89 566.214M131.867 565.686L127.267 561.833M131.867 565.686L131.339 559.709M131.867 565.686L135.72 561.087M131.867 565.686L137.844 565.158M131.867 565.686L136.466 569.539M131.999 567.18L132.037 567.607M132.131 568.674L132.263 570.169L132.307 570.667M130.904 566.836L130.629 567.165M129.941 567.986L128.977 569.136L128.656 569.519M130.373 565.818L129.946 565.856M128.879 565.95L127.384 566.082L126.886 566.126M130.717 564.723L130.389 564.448M129.567 563.76L128.417 562.796L128.034 562.475M131.735 564.192L131.697 563.765M131.603 562.698L131.471 561.204L131.427 560.706M132.83 564.536L133.105 564.208M133.793 563.386L134.757 562.237L135.078 561.853M133.361 565.554L133.788 565.516M134.855 565.422L136.35 565.29L136.848 565.246M133.017 566.649L133.345 566.925M134.167 567.613L135.317 568.576L135.7 568.897",
    stroke: "#9670DD",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.946 565.479L157.474 571.456M156.946 565.479L153.093 570.079M156.946 565.479L150.969 566.007M156.946 565.479L152.347 561.626M156.946 565.479L156.418 559.502M156.946 565.479L160.799 560.88M156.946 565.479L162.923 564.951M156.946 565.479L161.546 569.332M157.078 566.973L157.116 567.4M157.21 568.467L157.342 569.962L157.386 570.46M155.983 566.629L155.708 566.957M155.02 567.779L154.056 568.929L153.735 569.312M155.452 565.611L155.025 565.649M153.958 565.743L152.464 565.875L151.965 565.919M155.796 564.516L155.468 564.241M154.646 563.553L153.496 562.589L153.113 562.268M156.814 563.985L156.776 563.558M156.682 562.491L156.55 560.997L156.506 560.498M157.909 564.329L158.184 564.001M158.872 563.179L159.836 562.029L160.157 561.646M158.44 565.347L158.867 565.309M159.934 565.215L161.429 565.083L161.927 565.039M158.096 566.442L158.424 566.718M159.246 567.406L160.396 568.369L160.779 568.69",
    stroke: "#9670DD",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.636 575.151L116.164 581.128M115.636 575.151L111.784 579.75M115.636 575.151L109.66 575.679M115.636 575.151L111.037 571.298M115.636 575.151L115.109 569.174M115.636 575.151L119.489 570.551M115.636 575.151L121.613 574.623M115.636 575.151L120.236 579.004M115.768 576.645L115.806 577.072M115.9 578.139L116.032 579.634L116.076 580.132M114.673 576.301L114.398 576.629M113.71 577.451L112.747 578.601L112.426 578.984M114.142 575.283L113.715 575.321M112.648 575.415L111.154 575.547L110.656 575.591M114.487 574.188L114.158 573.913M113.337 573.225L112.187 572.261L111.804 571.94M115.505 573.657L115.467 573.23M115.373 572.163L115.241 570.668L115.197 570.17M116.6 574.001L116.875 573.673M117.563 572.851L118.526 571.701L118.847 571.318M117.131 575.019L117.558 574.981M118.625 574.887L120.119 574.755L120.617 574.711M116.786 576.114L117.115 576.389M117.936 577.077L119.086 578.041L119.469 578.362",
    stroke: "#9670DD",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.586 529.242L113.114 535.219M112.586 529.242L108.733 533.841M112.586 529.242L106.609 529.77M112.586 529.242L107.986 525.389M112.586 529.242L112.058 523.265M112.586 529.242L116.439 524.642M112.586 529.242L118.562 528.714M112.586 529.242L117.185 533.095M112.718 530.736L112.755 531.163M112.85 532.23L112.982 533.724L113.026 534.222M111.622 530.392L111.347 530.72M110.659 531.542L109.696 532.691L109.375 533.075M111.092 529.374L110.665 529.411M109.597 529.506L108.103 529.638L107.605 529.682M111.436 528.279L111.107 528.003M110.286 527.315L109.136 526.352L108.753 526.031M112.454 527.748L112.416 527.321M112.322 526.253L112.19 524.759L112.146 524.261M113.549 528.092L113.824 527.763M114.512 526.942L115.475 525.792L115.796 525.409M114.08 529.11L114.507 529.072M115.574 528.978L117.068 528.846L117.566 528.802M113.736 530.205L114.064 530.48M114.885 531.168L116.035 532.131L116.419 532.453",
    stroke: "#9670DD",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.17 513.128L113.698 519.104M113.17 513.128L109.317 517.727M113.17 513.128L107.193 513.655M113.17 513.128L108.57 509.275M113.17 513.128L112.642 507.151M113.17 513.128L117.023 508.528M113.17 513.128L119.146 512.6M113.17 513.128L117.769 516.98M113.302 514.622L113.339 515.049M113.434 516.116L113.566 517.61L113.61 518.108M112.206 514.277L111.931 514.606M111.243 515.427L110.28 516.577L109.959 516.96M111.676 513.26L111.249 513.297M110.181 513.391L108.687 513.523L108.189 513.567M112.02 512.164L111.691 511.889M110.87 511.201L109.72 510.238L109.337 509.917M113.038 511.633L113 511.206M112.906 510.139L112.774 508.645L112.73 508.147M114.133 511.978L114.408 511.649M115.096 510.828L116.059 509.678L116.38 509.295M114.664 512.996L115.091 512.958M116.158 512.864L117.652 512.732L118.15 512.688M114.32 514.091L114.648 514.366M115.469 515.054L116.619 516.017L117.003 516.338",
    stroke: "#9670DD",
    strokeWidth: 1.5
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 67.9678,
    y: 558.279,
    width: 3,
    height: 96,
    rx: 1.5,
    transform: "rotate(-95.0478 67.9678 558.279)",
    fill: "#1F454A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 96.0605,
    y: 512.631,
    width: 3,
    height: 66,
    rx: 1.5,
    transform: "rotate(-5.04778 96.0605 512.631)",
    fill: "#1F454A"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M100.642 553.144C88.3735 552.431 74.6074 538.594 80.4941 532.76C86.3809 526.926 96.6759 544.937 100.642 553.144Z",
    stroke: "#1F454A",
    strokeWidth: 3
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M102.539 554.518C115.933 548.803 125.946 529.52 117.144 526.163C108.341 522.807 103.8 544.795 102.539 554.518Z",
    stroke: "#1F454A",
    strokeWidth: 3
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0318 581.517C89.1047 582.342 89.8328 582.952 90.658 582.879C91.4832 582.806 92.0931 582.078 92.0202 581.253L90.526 581.385L89.0318 581.517ZM102.096 553.257L100.929 552.315C98.5723 555.231 95.3416 559.455 92.8318 564.456C90.324 569.453 88.485 575.325 89.0318 581.517L90.526 581.385L92.0202 581.253C91.5398 575.813 93.1479 570.515 95.513 565.802C97.8761 561.093 100.944 557.069 103.263 554.2L102.096 553.257Z",
    fill: "#1F454A"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M116.44 566.092C117.02 566.683 117.012 567.633 116.421 568.213C115.829 568.794 114.88 568.785 114.299 568.194L115.37 567.143L116.44 566.092ZM100.104 553.433L100.735 552.072C103.658 553.427 105.961 555.299 108.334 557.63C109.516 558.791 110.731 560.081 112.046 561.483C113.367 562.891 114.799 564.421 116.44 566.092L115.37 567.143L114.299 568.194C112.631 566.494 111.175 564.939 109.859 563.536C108.537 562.127 107.363 560.881 106.232 559.77C103.979 557.558 101.959 555.946 99.4733 554.794L100.104 553.433Z",
    fill: "#1F454A"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dn_30453_30598)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.253 563.979C224.197 593.441 196.095 639.859 157.5 629.642L104.95 615.732C92.5371 612.446 79.3009 615.32 69.3673 623.457L57.4147 633.248C45.6389 642.894 29.4089 645.02 15.5458 638.733L-16.0559 624.4C-26.5906 619.623 -33.5074 609.287 -33.9068 597.726C-34.2831 586.836 -28.8098 576.575 -19.5556 570.822L6.93045 554.355C17.2333 547.949 29.8865 546.566 41.3301 550.594L106.832 573.648C120.387 578.419 135.295 571.659 140.637 558.318L140.905 557.648C145.825 545.362 159.184 538.728 171.945 542.234C176.675 543.533 180.941 546.143 184.251 549.762L197.253 563.979Z",
    fill: "url(#paint1_linear_30453_30598)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dn_30453_30598)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.334 990.553C286.978 1016.1 269.082 1044.48 241.44 1045.88L-20.5521 1059.2C-44.5847 1060.42 -64.2479 1040.3 -62.4734 1016.3L-61.2701 1000.03C-60.3022 986.938 -52.9742 975.157 -41.6612 968.501L5.79847 940.581C15.7297 934.739 27.6979 933.463 38.6377 937.08L139.373 970.388C158.217 976.618 178.691 967.365 186.466 949.104C193.605 932.338 211.601 922.958 229.434 926.709L231.088 927.057C243.981 929.768 254.712 938.655 259.779 950.817L276.334 990.553Z",
    fill: "url(#paint2_linear_30453_30598)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_30453_30598)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.1709,
    y: 986.499,
    width: 96,
    height: 77,
    rx: 20,
    transform: "rotate(6.66694 90.1709 986.499)",
    fill: "#763499"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0529 992.103L101.57 1007.21L85.2269 1005.3L95.0529 992.103Z",
    fill: "#DB78D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.793 1011.9L107.31 1027.01L90.9672 1025.1L100.793 1011.9Z",
    fill: "#DB78D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9006 1027.4L93.4178 1042.5L77.0746 1040.59L86.9006 1027.4Z",
    fill: "#DB78D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.952 1036.67L112.47 1051.78L96.1264 1049.87L105.952 1036.67Z",
    fill: "#DB78D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.861 1040.26L160.378 1055.37L144.035 1053.45L153.861 1040.26Z",
    fill: "#DB78D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.729 1057.85L147.246 1072.96L130.903 1071.05L140.729 1057.85Z",
    fill: "#DB78D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.007 1054.07L123.524 1069.18L107.181 1067.27L117.007 1054.07Z",
    fill: "#DB78D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0666 1052.05L97.5838 1067.15L81.2406 1065.24L91.0666 1052.05Z",
    fill: "#DB78D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.023 1037.47L136.54 1052.58L120.197 1050.67L130.023 1037.47Z",
    fill: "#DB78D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.705 1042.93L183.223 1058.04L166.879 1056.13L176.705 1042.93Z",
    fill: "#DB78D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.851 995.586L131.368 1010.7L115.025 1008.78L124.851 995.586Z",
    fill: "#DB78D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.522 1015.57L130.039 1030.68L113.696 1028.77L123.522 1015.57Z",
    fill: "#DB78D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.668 998.721L158.185 1013.83L141.842 1011.92L151.668 998.721Z",
    fill: "#DB78D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.469 1017.48L154.986 1032.59L138.643 1030.67L148.469 1017.48Z",
    fill: "#DB78D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.313 1020.15L177.83 1035.26L161.487 1033.34L171.313 1020.15Z",
    fill: "#DB78D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.486 1001.86L185.003 1016.96L168.66 1015.05L178.486 1001.86Z",
    fill: "#DB78D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1991 991.961C99.5929 989.422 101.722 990.975 101.722 990.975C101.722 990.975 103.945 988.731 107.507 991.651C120.181 1002.04 105.793 1026.24 113.121 1041.03C124.193 1063.39 164.965 1044.36 173.323 1060.18C176.615 1066.4 176.235 1070 170.35 1073.8C155.798 1083.2 109.544 1071.63 109.544 1071.63C109.544 1071.63 95.3637 1072.29 87.2487 1059.98C81.0538 1050.58 85.0963 1032.52 87.0288 1021.31C89.0605 1009.53 85.079 997.811 95.1991 991.961Z",
    fill: "#632260",
    fillOpacity: 0.6
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 87.915,
    y: 967.75,
    width: 92.7472,
    height: 26.3423,
    rx: 10,
    transform: "rotate(6.66694 87.915 967.75)",
    fill: "#44286B"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 133.122,
    y: 969.016,
    width: 3.53323,
    height: 87.8077,
    rx: 1.76661,
    transform: "rotate(6.66694 133.122 969.016)",
    fill: "#73A1FD"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M134.056 971.343C117.541 967.596 102.108 950.582 111.499 946.31C120.89 942.038 130.612 962.293 134.056 971.343Z",
    stroke: "#73A1FD",
    strokeWidth: 4
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M135.465 972.742C152.071 970.085 167.975 954.1 158.714 949.215C149.454 944.33 139.164 963.927 135.465 972.742Z",
    stroke: "#73A1FD",
    strokeWidth: 4
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M119.312 984.681C119.183 985.778 119.969 986.771 121.066 986.899C122.163 987.028 123.156 986.242 123.285 985.145L121.298 984.913L119.312 984.681ZM135.295 971.681L134.418 969.883C131.961 971.082 128.482 972.882 125.505 975.243C122.58 977.562 119.776 980.706 119.312 984.681L121.298 984.913L123.285 985.145C123.562 982.777 125.32 980.494 127.99 978.377C130.608 976.301 133.757 974.657 136.172 973.478L135.295 971.681Z",
    fill: "#73A1FD"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M145.844 986.587C146.392 987.546 146.059 988.768 145.1 989.316C144.141 989.864 142.919 989.531 142.371 988.572L144.108 987.579L145.844 986.587ZM133.54 971.476L134.807 969.929C137.161 971.858 138.836 974.17 140.453 976.887C141.259 978.24 142.067 979.724 142.935 981.323C143.808 982.931 144.75 984.672 145.844 986.587L144.108 987.579L142.371 988.572C141.251 986.612 140.288 984.831 139.419 983.231C138.546 981.621 137.775 980.207 137.016 978.933C135.506 976.395 134.111 974.53 132.272 973.023L133.54 971.476Z",
    fill: "#73A1FD"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_dn_30453_30598)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-143.287 1101.23C-146.884 1127.94 -123.567 1150.49 -96.9881 1146.01L120.981 1109.22C144.538 1105.24 159.38 1081.64 152.756 1058.69L149.201 1046.37C144.984 1031.75 132.843 1020.8 117.875 1018.09L73.0366 1010C64.0713 1008.38 54.8223 1009.87 46.8194 1014.23L-27.122 1054.44C-43.5702 1063.39 -64.1333 1058.17 -74.3181 1042.45L-75.3578 1040.85C-84.6609 1026.5 -103.241 1021.39 -118.57 1028.98C-128.61 1033.95 -135.525 1043.58 -137.02 1054.68L-143.287 1101.23Z",
    fill: "url(#paint3_linear_30453_30598)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_dn_30453_30598)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.207 340.126C153.396 363.381 136.622 385.179 113.07 387.087L-1.30394 396.351C-26.5007 398.391 -36.0329 364.173 -13.41 352.893L9.29091 339.113C18.142 333.741 29.0703 333.069 38.513 337.316L46.0372 340.701C60.8693 347.372 78.0232 338.334 80.9061 322.328C83.8723 305.86 101.862 296.895 116.796 304.443L129.531 310.879C139.513 315.924 146.548 325.362 148.531 336.37L149.207 340.126Z",
    fill: "url(#paint4_linear_30453_30598)"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1.18457 0L21.8399 63.9159H88.6818L34.6055 103.418L55.2608 167.334L1.18457 127.832L-52.8917 167.334L-32.2364 103.418L-86.3126 63.9159H-19.4707L1.18457 0Z",
    fill: "#FEC414"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M3.68457 51L13.0019 79.6758H43.1534L18.7603 97.3984L28.0777 126.074L3.68457 108.352L-20.7085 126.074L-11.3912 97.3984L-35.7843 79.6758H-5.63276L3.68457 51Z",
    fill: "#FFDF7E"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_30453_30598)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -13.7422,
    y: 1073.13,
    width: 96,
    height: 77,
    rx: 20,
    transform: "rotate(38.5679 -13.7422 1073.13)",
    fill: "#34838B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.919 1152.43L9.46755 1168.7L-3.39771 1158.44L11.919 1152.43Z",
    fill: "#46A8A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0205 1176.01L8.56911 1192.28L-4.29615 1182.02L11.0205 1176.01Z",
    fill: "#46A8A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9024 1166.76L27.4509 1183.04L14.5857 1172.78L29.9024 1166.76Z",
    fill: "#46A8A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8965 1099.17L8.44509 1115.44L-4.42017 1105.18L10.8965 1099.17Z",
    fill: "#46A8A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.790013 1115.43L-3.24143 1131.7L-16.1067 1121.45L-0.790013 1115.43Z",
    fill: "#46A8A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0078 1116L29.5564 1132.28L16.6912 1122.02L32.0078 1116Z",
    fill: "#46A8A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3799 1130.24L16.9285 1146.51L4.06323 1136.25L19.3799 1130.24Z",
    fill: "#46A8A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3633 1144.58L34.9119 1160.85L22.0466 1150.59L37.3633 1144.58Z",
    fill: "#46A8A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1182 1132.84L50.6668 1149.11L37.8015 1138.85L53.1182 1132.84Z",
    fill: "#46A8A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-12.3604 1080.43C-7.28815 1080.59 -6.30156 1083.04 -6.30156 1083.04C-6.30156 1083.04 -3.22851 1082.31 -1.74714 1086.67C3.52292 1102.18 -21.479 1115.12 -23.077 1131.56C-25.4919 1156.39 19.1772 1161.78 17.9162 1179.62C17.4195 1186.65 15.1945 1189.5 8.19126 1189.62C-9.12893 1189.91 -42.2814 1155.64 -42.2814 1155.64C-42.2814 1155.64 -54.6692 1148.71 -55.0538 1133.97C-55.3473 1122.72 -42.3689 1109.52 -34.806 1101.02C-26.8552 1092.1 -24.0432 1080.04 -12.3604 1080.43Z",
    fill: "#2A6D73",
    fillOpacity: 0.55
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: -5.74902,
    y: 1056.02,
    width: 92.7472,
    height: 26.3423,
    rx: 10,
    transform: "rotate(38.5679 -5.74902 1056.02)",
    fill: "#28646B"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 31.9609,
    y: 1080.99,
    width: 3.53323,
    height: 87.8077,
    rx: 1.76661,
    transform: "rotate(38.5679 31.9609 1080.99)",
    fill: "#FAAF59"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5243 1083.46C19.4838 1071.55 15.373 1048.95 25.6031 1050.28C35.8332 1051.62 33.3828 1073.95 31.5243 1083.46Z",
    stroke: "#FAAF59",
    strokeWidth: 4
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9808 1085.39C47.4829 1091.91 69.4314 1086.74 64.1512 1077.7C58.8711 1068.66 39.7795 1079.86 31.9808 1085.39Z",
    stroke: "#FAAF59",
    strokeWidth: 4
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M11.958 1086.99C11.2694 1087.85 11.4112 1089.11 12.2749 1089.8C13.1385 1090.49 14.3968 1090.34 15.0855 1089.48L13.5217 1088.23L11.958 1086.99ZM32.3973 1084.4L32.6027 1082.41C29.8829 1082.13 25.9782 1081.82 22.2035 1082.25C18.4945 1082.67 14.4527 1083.86 11.958 1086.99L13.5217 1088.23L15.0855 1089.48C16.5721 1087.62 19.2716 1086.61 22.6568 1086.22C25.9763 1085.84 29.5188 1086.11 32.192 1086.39L32.3973 1084.4Z",
    fill: "#FAAF59"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4764 1102.63C33.4349 1103.73 32.5065 1104.59 31.4027 1104.55C30.2989 1104.51 29.4377 1103.58 29.4792 1102.48L31.4778 1102.55L33.4764 1102.63ZM31.0157 1083.3L32.9095 1082.65C33.8882 1085.53 34.0885 1088.38 34.0259 1091.54C33.9947 1093.12 33.8969 1094.8 33.7886 1096.62C33.6798 1098.45 33.5592 1100.42 33.4764 1102.63L31.4778 1102.55L29.4792 1102.48C29.564 1100.22 29.6874 1098.2 29.7957 1096.38C29.9047 1094.55 29.9973 1092.95 30.0267 1091.46C30.0851 1088.51 29.8868 1086.19 29.122 1083.94L31.0157 1083.3Z",
    fill: "#FAAF59"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_30453_30598)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70.0234,
    y: 1236.48,
    width: 96,
    height: 141,
    rx: 20,
    transform: "rotate(-23.0986 70.0234 1236.48)",
    fill: "#26575E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.6914,
    y: 1288.92,
    width: 68.7266,
    height: 8,
    transform: "rotate(-68.0986 83.6914 1288.92)",
    fill: "#DF5018"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.6211,
    y: 1317.5,
    width: 126.42,
    height: 8,
    transform: "rotate(-68.0986 92.6211 1317.5)",
    fill: "#DF5018"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.067,
    y: 1333.94,
    width: 126.42,
    height: 8,
    transform: "rotate(-68.0986 105.067 1333.94)",
    fill: "#DF5018"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.291,
    y: 1371.88,
    width: 186.606,
    height: 8,
    transform: "rotate(-68.0986 109.291 1371.88)",
    fill: "#DF5018"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.847,
    y: 1383.07,
    width: 186.606,
    height: 8,
    transform: "rotate(-68.0986 123.847 1383.07)",
    fill: "#DF5018"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.321,
    y: 1393.86,
    width: 186.606,
    height: 8,
    transform: "rotate(-68.0986 139.321 1393.86)",
    fill: "#DF5018"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.38,
    y: 1400.72,
    width: 186.606,
    height: 8,
    transform: "rotate(-68.0986 156.38 1400.72)",
    fill: "#DF5018"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5333 1248.46C78.7992 1242.19 81.9751 1243.1 81.9751 1243.1C81.9751 1243.1 82.406 1238.57 87.96 1240.55C107.719 1247.6 112.156 1290.69 130.142 1307.25C157.32 1332.27 181.735 1280.5 201.458 1297.88C209.226 1304.72 211.552 1310.06 208.815 1319.03C202.046 1341.21 149.595 1352.86 149.595 1352.86C149.595 1352.86 136.657 1362.41 119.781 1349.86C106.898 1340.28 97.2405 1312.18 90.7046 1295.09C83.8335 1277.13 71.3145 1262.91 76.5333 1248.46Z",
    fill: "#153538",
    fillOpacity: 0.35
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 65.2471,
    y: 1235.48,
    width: 105,
    height: 30.75,
    rx: 10,
    transform: "rotate(-23.0986 65.2471 1235.48)",
    fill: "#306C73"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 110.142,
    y: 1213.29,
    width: 4,
    height: 136.045,
    rx: 2,
    transform: "rotate(-23.0986 110.142 1213.29)",
    fill: "#FAAF59"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M112.399 1215.12C94.0384 1220.67 69.0999 1212.13 75.8542 1202.48C82.6086 1192.83 103.809 1207.89 112.399 1215.12Z",
    stroke: "#FAAF59",
    strokeWidth: 4
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M114.586 1215.75C129.349 1203.65 135.75 1178.43 123.851 1178.71C111.953 1179 113.14 1204.71 114.586 1215.75Z",
    stroke: "#FAAF59",
    strokeWidth: 4
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M110.756 1247.87C111.19 1248.88 112.365 1249.36 113.381 1248.92C114.397 1248.49 114.869 1247.31 114.436 1246.3L112.596 1247.08L110.756 1247.87ZM114.096 1214.92L112.204 1214.27C109.719 1221.55 105.504 1235.55 110.756 1247.87L112.596 1247.08L114.436 1246.3C109.848 1235.54 113.479 1222.91 115.989 1215.56L114.096 1214.92Z",
    fill: "#FAAF59"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M136.73 1228.01C137.643 1228.63 137.879 1229.87 137.258 1230.79C136.636 1231.7 135.392 1231.93 134.479 1231.31L135.605 1229.66L136.73 1228.01ZM112.256 1215.7L112.718 1213.75C116.621 1214.68 120.059 1216.53 123.766 1218.96C127.359 1221.32 131.644 1224.54 136.73 1228.01L135.605 1229.66L134.479 1231.31C129.059 1227.62 125.241 1224.71 121.571 1222.3C118.016 1219.97 115.034 1218.41 111.795 1217.65L112.256 1215.7Z",
    fill: "#FAAF59"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dn_30453_30598",
    x: -17.8828,
    y: 731.729,
    width: 264.722,
    height: 109.269,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_30453_30598"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "1 1",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 7062
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "shape",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise2"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "shape",
    in: "coloredNoise2",
    result: "noise2Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(255, 255, 255, 0.6)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(255, 255, 255, 0.25)",
    result: "color2Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise2Clipped",
    in: "color2Flood",
    result: "color2"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect2_noise_30453_30598"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shape"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color2"
  })), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "effect2_noise_30453_30598",
    in2: "effect1_dropShadow_30453_30598",
    result: "effect2_noise_30453_30598"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dn_30453_30598",
    x: -37.9248,
    y: 541.3,
    width: 249.845,
    height: 109.004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_30453_30598"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "1 1",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 7062
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "shape",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise2"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "shape",
    in: "coloredNoise2",
    result: "noise2Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(255, 255, 255, 0.6)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(255, 255, 255, 0.25)",
    result: "color2Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise2Clipped",
    in: "color2Flood",
    result: "color2"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect2_noise_30453_30598"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shape"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color2"
  })), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "effect2_noise_30453_30598",
    in2: "effect1_dropShadow_30453_30598",
    result: "effect2_noise_30453_30598"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dn_30453_30598",
    x: -66.585,
    y: 925.887,
    width: 350.03,
    height: 141.366,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_30453_30598"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "1 1",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 7062
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "shape",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise2"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "shape",
    in: "coloredNoise2",
    result: "noise2Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(255, 255, 255, 0.6)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(255, 255, 255, 0.25)",
    result: "color2Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise2Clipped",
    in: "color2Flood",
    result: "color2"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect2_noise_30453_30598"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shape"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color2"
  })), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "effect2_noise_30453_30598",
    in2: "effect1_dropShadow_30453_30598",
    result: "effect2_noise_30453_30598"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_dn_30453_30598",
    x: -147.655,
    y: 1009.36,
    width: 305.995,
    height: 145.213,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_30453_30598"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "1 1",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 7062
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "shape",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise2"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "shape",
    in: "coloredNoise2",
    result: "noise2Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(255, 255, 255, 0.6)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(255, 255, 255, 0.25)",
    result: "color2Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise2Clipped",
    in: "color2Flood",
    result: "color2"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect2_noise_30453_30598"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shape"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color2"
  })), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "effect2_noise_30453_30598",
    in2: "effect1_dropShadow_30453_30598",
    result: "effect2_noise_30453_30598"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_dn_30453_30598",
    x: -30.1846,
    y: 301.736,
    width: 184.034,
    height: 102.702,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_30453_30598"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "1 1",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 7062
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "shape",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise2"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "shape",
    in: "coloredNoise2",
    result: "noise2Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(255, 255, 255, 0.6)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(255, 255, 255, 0.25)",
    result: "color2Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise2Clipped",
    in: "color2Flood",
    result: "color2"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect2_noise_30453_30598"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shape"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color2"
  })), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "effect2_noise_30453_30598",
    in2: "effect1_dropShadow_30453_30598",
    result: "effect2_noise_30453_30598"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_30453_30598",
    x1: 117.764,
    y1: 793.068,
    x2: 108.987,
    y2: 716.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFDFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_30453_30598",
    x1: 77.3713,
    y1: 601.773,
    x2: 67.4921,
    y2: 525.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFDFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_30453_30598",
    x1: 97.2682,
    y1: 1007.52,
    x2: 84.6994,
    y2: 906.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFDFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_30453_30598",
    x1: 13.9408,
    y1: 1081.01,
    x2: 5.47506,
    y2: 980.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFDFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_30453_30598",
    x1: 72.0583,
    y1: 375.455,
    x2: 59.9932,
    y2: 300.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFDFFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30453_30598"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 67.4365,
    y: 518.171,
    width: 89,
    height: 61,
    rx: 20,
    transform: "rotate(-5.04778 67.4365 518.171)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_30453_30598"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.1709,
    y: 986.499,
    width: 84.7974,
    height: 61.4654,
    rx: 20,
    transform: "rotate(6.66694 90.1709 986.499)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_30453_30598"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -13.7422,
    y: 1073.13,
    width: 84.7974,
    height: 61.4654,
    rx: 20,
    transform: "rotate(38.5679 -13.7422 1073.13)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_30453_30598"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70.0234,
    y: 1236.48,
    width: 96,
    height: 125.795,
    rx: 20,
    transform: "rotate(-23.0986 70.0234 1236.48)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFalltree);
export default __webpack_public_path__ + "static/media/Falltree.1d3b3324aa7a5e85c1e22c07c2127e24.svg";
export { ForwardRef as ReactComponent };